const MissionsSearchForm = () => import("@/components/MissionsSearchForm/MissionsSearchForm.vue");
const MissionDetail = () => import("@/components/MissionDetail/MissionDetail.vue");

import searchGenericMissions from "@/mixins/searchGenericMissions.js";

export default {
  components: {
    MissionsSearchForm,
    MissionDetail,
  },
  mixins: [searchGenericMissions],
  data() {
    return {
      error: false,
      loading: true,
      missionsList: [],
      perPage: 10,
      currentPage: 1,
      isEmpty: false
    };
  },
  computed: {
    isLoggedIn() {
      return localStorage.getItem("isAuthenticated");
    },
    missions() {
      return this.missionsList.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      const vue = this;
      if(this.$route.query.locality) {
        this.searchGenericMissions(this.$route.query.lat, this.$route.query.lng);
      } else if(this.isLoggedIn) {
        setTimeout(() => {
          const geocoder = new google.maps.Geocoder();
          const defaultAddress = "Paris"
          geocoder.geocode({ address: defaultAddress }, (results, status) => {
            if (status === "OK") {
              const lat = results[0].geometry.location.lat();
              const lng = results[0].geometry.location.lng();
              vue.$router.replace({
                path: vue.$router.history.current.path,
                query: {
                  locality: defaultAddress,
                  lat: lat,
                  lng: lng,
                },
              });
              vue.searchGenericMissions(lat, lng);
              vue.$refs.searchform.full_address = defaultAddress;
            }
          });
        }, 2000);
      } else {
        this.isEmpty = true;
      }
    },
    changePage(page) {
      window.scrollTo(0, 0);
    },
    triggerSearch(lat, lng) {
      this.isEmpty = !lat && !lng;
      this.missionsList = [];
      this.searchGenericMissions(lat, lng);
    },
  },
};